import AbstractModel from './AbstractModel';

class ManufacturerModel extends AbstractModel {}

export default ManufacturerModel;
